import React, { JSX, ReactNode } from 'react';
import { Loader, Theme, ThemeProvider } from '@aws-amplify/ui-react';
import { PostMessageRequest } from '@/model/PostMessageRequest';
import { LivenessError } from '@/model/LivenessError';
import { LivenessErrorContent } from '@/model/LivenessErrorContent';
import { FaceLivenessDetectorScreen } from '../../FaceLivenessDetector';
import { FaceLivenessSuccess } from '../../FaceLivenessSuccess';
import { FaceLivenessError } from '../../FaceLivenessError';
import { FaceLivenessInstructions } from '../../FaceLivenessInstructions';

interface StateProps {
  loading: boolean;
  sessionId?: string;
  screen: number;
  postMessageRequest?: PostMessageRequest;
  livenessErrorContent?: LivenessErrorContent;
}

interface DispatchProps {
  onAnalysisComplete: () => Promise<void>;
  onError: (livenessError: LivenessError) => void;
  nextScreen: () => void;
  backScreen: () => void;
}

type Props = StateProps & DispatchProps;

export const FaceContainer: React.FC<Props> = ({
  loading,
  sessionId,
  screen,
  postMessageRequest,
  onAnalysisComplete,
  onError,
  livenessErrorContent,
  nextScreen,
  backScreen,
}): JSX.Element => {
  const content = (): ReactNode => {
    let contentScreen;

    switch (screen) {
      case 0:
        contentScreen = (
          <FaceLivenessInstructions
            postMessageRequest={postMessageRequest}
            nextScreen={nextScreen}
          />
        );
        break;
      case 1:
        contentScreen =
          postMessageRequest && postMessageRequest.origin ? (
            <FaceLivenessDetectorScreen
              loading={loading}
              sessionId={sessionId}
              onAnalysisComplete={onAnalysisComplete}
              onError={error => onError(error as LivenessError)}
            />
          ) : (
            <div />
          );
        break;

      case 2:
        contentScreen = (
          <FaceLivenessError livenessErrorContent={livenessErrorContent} backScreen={backScreen} />
        );
        break;
      case 3:
        contentScreen = <FaceLivenessSuccess />;
        break;
      default:
        contentScreen = <Loader />;
        break;
    }
    return contentScreen;
  };

  const theme: Theme = {
    name: 'my-theme',
    tokens: {
      colors: {
        font: {
          primary: { value: '#1a202c' },
          secondary: { value: '#2d3748' },
          tertiary: { value: '#ed8936' },
        },
      },
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <div className="wrapper w-full">
        <main className="overflow-hidden">{content()}</main>
      </div>
    </ThemeProvider>
  );
};
